export default __webpack_public_path__ + "static/m-process-07-e6ea5c8abfe6ae29b7e68c9798492066.svg";